// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillRest, neutralForegroundHint, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const DeleteMenuMenuStyles = (config: DesignSystem) =>  ({
    deleteMenuContainer: {
        overflow: "hidden",
        position: "relative",
        width: "170px",
        background: neutralLayerCard,
        "border-radius": "8px",
        "box-shadow": "0px 0px 5.6px rgba(0, 0, 0, 0.11), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)",
        transition: ".2s ease",

        "& .cwt-icon.cwt-menu-header": {
            "font-size": "16px",
            [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "auto",
            padding: "4px 8px 0",
            color: neutralForegroundHint,
            fill: "currentColor",

            "& .cwt-icon-label": {
                "font-size": "12px",
                "font-weight": "bold"
            }
        },

        "& .cwt-delete-list": {
            "min-width": "140px",
            "max-height": "188px",
            padding: "4px 0",
            "font-size": "12px",
            "letter-spacing": applyLocalizedProperty("-0.012em", "0", config.direction),
            "overflow-y": "auto",

            "& li": {
                cursor: "pointer",
                padding: "4px 12px",
                color: neutralForegroundHint,

                "&:hover": {
                    background: neutralFillRest
                }
            }
        }
    }
});